import { readMetrics } from '@/services/userbeat/storage';
import dayjs from 'dayjs';

export function shouldSendMetric(metricName: string): boolean {
  const currentValue = readMetrics();
  if (currentValue.length === 0) {
    return true;
  }
  const metric = currentValue.find(
    (metric) => metric.metricName === metricName,
  );
  if (metric === null || metric === undefined) {
    return true;
  }
  const metricDate = dayjs(metric.lastSend);
  const currentDate = dayjs(new Date());
  return metricDate.isBefore(currentDate, 'day');
}
